import {GRADIENT_TYPE, OBSTACLE_TYPE} from "./../ENUM.js";
import * as SOUND_DATA from "./../SOUND_DATA.js";
import * as SOUND_IDS from "./../SOUND_IDS.js";


export const BLRDS = {
  isDark: true,
  startHealth: 5,
  timeAllowedSecs: 50,
  textColor: "#faffab",
  textColorHighlight: "#dd5905",
  bgColor: "#008c00",
  bgFadeAlpha: 0.55,
  gameplayAreaToCanvasLateralRatio: 0.8,
  controllerSpeedDamp: 100,
  player: {
    color: "#ffffff",
    growthDivisor: 100,
    radius: 50,
  },
  obstacles: [
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_DROP_SFX_AR,
      total: 1,
      color_ar: ["#000000"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.RADIAL_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.01 },
          { color: "#000000", pos: 0.01 },
        ],
      },
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_DROP_SFX_AR,
      total: 1,
      color_ar: ["#ff6600"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.RADIAL_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.01 },
          { color: "#ff6600", pos: 0.01 },
        ],
      },
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      damageSfx: SOUND_IDS.SFX_CLACK_5,
      total: 1,
      color_ar: ["#ff6600"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.LINEAR_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.3 },
          { color: "#ff6600", pos: 0.3 },
          { color: "#ff6600", pos: 0.7 },
          { color: "#ffffff", pos: 0.7 },
          { color: "#ffffff", pos: 1 },
        ],
      },
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_DROP_SFX_AR,
      total: 1,
      color_ar: ["#006600"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.RADIAL_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.01 },
          { color: "#006600", pos: 0.01 },
        ],
      },
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      damageSfx: SOUND_IDS.SFX_CLACK_5,
      total: 1,
      color_ar: ["#006600"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.LINEAR_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.3 },
          { color: "#006600", pos: 0.3 },
          { color: "#006600", pos: 0.7 },
          { color: "#ffffff", pos: 0.7 },
          { color: "#ffffff", pos: 1 },
        ],
      },
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_DROP_SFX_AR,
      total: 1,
      color_ar: ["#500066"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.RADIAL_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.01 },
          { color: "#500066", pos: 0.01 },
        ],
      },
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      damageSfx: SOUND_IDS.SFX_CLACK_5,
      total: 1,
      color_ar: ["#500066"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.LINEAR_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.3 },
          { color: "#500066", pos: 0.3 },
          { color: "#500066", pos: 0.7 },
          { color: "#ffffff", pos: 0.7 },
          { color: "#ffffff", pos: 1 },
        ],
      },
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_DROP_SFX_AR,
      total: 1,
      color_ar: ["#cccc00"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.RADIAL_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.01 },
          { color: "#cccc00", pos: 0.01 },
        ],
      },
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      damageSfx: SOUND_IDS.SFX_CLACK_5,
      total: 1,
      color_ar: ["#cccc00"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.LINEAR_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.3 },
          { color: "#cccc00", pos: 0.3 },
          { color: "#cccc00", pos: 0.7 },
          { color: "#ffffff", pos: 0.7 },
          { color: "#ffffff", pos: 1 },
        ],
      },
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_DROP_SFX_AR,
      total: 1,
      color_ar: ["#dd0000"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.RADIAL_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.01 },
          { color: "#dd0000", pos: 0.01 },
        ],
      },
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      damageSfx: SOUND_IDS.SFX_CLACK_5,
      total: 1,
      color_ar: ["#dd0000"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.LINEAR_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.3 },
          { color: "#dd0000", pos: 0.3 },
          { color: "#dd0000", pos: 0.7 },
          { color: "#ffffff", pos: 0.7 },
          { color: "#ffffff", pos: 1 },
        ],
      },
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_DROP_SFX_AR,
      total: 1,
      color_ar: ["#000066"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.RADIAL_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.01 },
          { color: "#000066", pos: 0.01 },
        ],
      },
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      damageSfx: SOUND_IDS.SFX_CLACK_5,
      total: 1,
      color_ar: ["#000066"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.LINEAR_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.3 },
          { color: "#000066", pos: 0.3 },
          { color: "#000066", pos: 0.7 },
          { color: "#ffffff", pos: 0.7 },
          { color: "#ffffff", pos: 1 },
        ],
      },
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_DROP_SFX_AR,
      total: 1,
      color_ar: ["#581900"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.RADIAL_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.01 },
          { color: "#581900", pos: 0.01 },
        ],
      },
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      damageSfx: SOUND_IDS.SFX_CLACK_5,
      total: 1,
      color_ar: ["#581900"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      rotationSpeedRange: [0.1, 0.2],
      gradient: {
        type: GRADIENT_TYPE.LINEAR_TUMBLING,
        stop_ar: [
          { color: "#ffffff", pos: 0 },
          { color: "#ffffff", pos: 0.3 },
          { color: "#581900", pos: 0.3 },
          { color: "#581900", pos: 0.7 },
          { color: "#ffffff", pos: 0.7 },
          { color: "#ffffff", pos: 1 },
        ],
      },
      useDefaultStroke: true,
    },
  ],
};
